import React from 'react';

import './CircleLoader.css';

export const CirclesLoader = () => {
  return <div className="circle-loader"></div>;
};
